export { default } from './ErrorInfo';
